<div class="dialog kultur-nav-search">
  <div mat-dialog-title class="modal-header">
    <h1 class="modal-title">
      <span>
        {{ 'TRANS__CULTURE_HUB_SEARCH__TITLE' | translate }}
      </span>
    </h1>

    <button
      type="button"
      mat-icon-button
      class="close"
      [tabindex]="-1"
      aria-label="close dialog"
      mat-dialog-close=""
    >
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>

  <app-kultur-nav-importer-items
    [dialogRef]="dialogRef"
    [kulturNavData]="data"
  ></app-kultur-nav-importer-items>
</div>
